import i18n from "i18next";

export function getCurrentRegion(defaultValue = "CA") {
  const splitLanguage = i18n.language?.split("-");

  return splitLanguage?.at(-1) ?? defaultValue;
}

export function getCurrentLocale(defaultValue = "en") {
  const splitLanguage = i18n.language?.split("-");

  return splitLanguage?.[0] ?? defaultValue;
}
